import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorBoundary } from "react-error-boundary";

export const Predent = (props) => {
    const navigate = useNavigate();
    const [openSter, setOpenSter] = useState(false);
    const [openXray, setOpenXray] = useState(false);
    const [openDentAssist, setOpenDentAssist] = useState(false);
    const [openOffice, setOpenOffice] = useState(false);

    const handleTrackNavigate = (track) => {
        navigate(`/${track}`);
    };

    const styles = {
        container: {
            backgroundColor: "#d7ffd9",
            color: "#1b5e20",
            minHeight: "100vh",
            padding: "30px",
            paddingTop: "100px"
        },
        sectionWrapper: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            gap: "20px",
            marginTop: "30px",
        },
        section: {
            flex: "1 1 calc(50% - 20px)",
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            padding: "20px",
            textAlign: "left",
        },
        calendarSection: {
            flex: "1 1 100%",
            backgroundColor: "#c8e6c9",
            borderRadius: "12px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            padding: "20px",
            textAlign: "center"
        },
        sectionTitle: {
            fontSize: "2rem",
            fontWeight: "bold",
            color: "#1b5e20",
            marginBottom: "15px",
        },
        sectionText: {
            fontSize: "1.2rem",
            lineHeight: "1.5",
            color: "#2e7d32",
            marginBottom: "20px",
        },
        iframe: {
            border: "none",
            width: "100%",
            maxWidth: "800px",
            height: "600px",
            borderRadius: "10px",
            boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
        },
        footer: {
            marginTop: "30px",
            textAlign: "center",
            fontSize: "1rem",
            color: "#388e3c",
            fontWeight: "bold",
        },
        trackButtonsWrapper: {
            display: "flex",
            gap: "12px",
            marginBottom: "30px",
            justifyContent: "flex-start",
            flexWrap: "wrap",
        },
        trackButton: {
            padding: "6px 14px",
            borderRadius: "8px",
            border: "2px solid #2e7d32",
            backgroundColor: "transparent",
            color: "#1b5e20",
            fontSize: "1.15rem",
            fontWeight: 600,
            cursor: "pointer",
            transition: "all 0.2s ease",
        },
        trackButtonActive: {
            padding: "6px 14px",
            borderRadius: "8px",
            border: "2px solid #1b5e20",
            backgroundColor: "#2e7d32",
            color: "white",
            fontSize: "1.15rem",
            fontWeight: 600,
            cursor: "default",
        },
    };

    return (
        <ErrorBoundary fallback={<div>Something went wrong</div>}>
            <div style={styles.container}>
                <h1 style={{ marginTop: 0, marginBottom: "20px", fontSize: "2.25rem", color: "#1b5e20", fontWeight: "bold", textTransform: "uppercase" }}>Pre-Dental</h1>
                {/* Track Navigation Buttons */}
                <div style={styles.trackButtonsWrapper}>
                    <button
                        onClick={() => handleTrackNavigate('premed')}
                        style={styles.trackButton}
                    >
                        Pre-Med
                    </button>
                    <button
                        onClick={() => handleTrackNavigate('predent')}
                        style={styles.trackButtonActive}
                        aria-current="page"
                    >
                        Pre-Dent
                    </button>
                    <button
                        onClick={() => handleTrackNavigate('prepa')}
                        style={styles.trackButton}
                    >
                        Pre-PA
                    </button>
                </div>

                {/* Calendar Section */}
                <section style={styles.calendarSection}>
                    <h2 style={styles.sectionTitle}>Calendar</h2>
                    <p style={styles.sectionText}>
                        Check upcoming events, workshops, and meetings related to Pre-Dental opportunities.
                    </p>
                    <div style={{ transform: "scale(0.9)", transformOrigin: "top center" }}>
                        <iframe
                            src="https://calendar.google.com/calendar/embed?src=c_f27ada5af520edfebabe1a23590c9bca061510b7116193520ab7ff90a5604be1%40group.calendar.google.com&ctz=America%2FNew_York"
                            style={styles.iframe}
                            title="PreDent Calendar"
                        ></iframe>
                    </div>
                </section>

                {/* Opportunities and Certifications */}
                <div style={styles.sectionWrapper}>
                    <section style={styles.section}>
                        <h2 style={styles.sectionTitle}>Opportunities</h2>
                        <p style={styles.sectionText}>
                            Discover shadowing programs, dental internships, and volunteer
                            opportunities to enhance your pre-dental journey. Connect with local
                            dental professionals and build your experience!
                        </p>
                    </section>

                    <section style={styles.section}>
                        <h2 style={styles.sectionTitle}>Dental Career Pathways and Requirements</h2>

                        {/* Sterilization Technician */}
                        <button
                            onClick={() => setOpenSter(o => !o)}
                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: "none", border: "none", borderBottom: "1px solid #a5d6a7", padding: "10px 0", cursor: "pointer", textAlign: "left" }}
                        >
                            <h3 style={{ margin: 0, fontSize: "1.5rem", color: "#1b5e20" }}>Sterilization Technician</h3>
                            <span style={{ fontSize: "1.2rem", color: "#2e7d32" }}>{openSter ? "▲" : "▼"}</span>
                        </button>
                        {openSter && (
                            <div style={{ paddingLeft: "10px", paddingTop: "8px", paddingBottom: "8px" }}>
                                <p style={{ ...styles.sectionText, marginBottom: "6px" }}><strong>Responsibilities:</strong> Instrument handling, sterilization, and tray preparation</p>
                                <p style={{ ...styles.sectionText, marginBottom: "4px" }}><strong>Certifications:</strong></p>
                                <ul style={{ paddingLeft: "20px", color: "#2e7d32", fontSize: "1.1rem", lineHeight: "1.8", marginBottom: "10px" }}>
                                    <li><a href="https://www.danb.org">Dental Assisting National Board (DANB)</a></li>
                                    <li><a href="https://www.iahcsmm.org">International Association of Healthcare Central Service Material Management (IAHCSMM)</a></li>
                                </ul>
                                <p style={{ ...styles.sectionText, marginBottom: "4px" }}><strong>Requirements:</strong></p>
                                <ul style={{ paddingLeft: "20px", color: "#2e7d32", fontSize: "1.1rem", lineHeight: "1.8" }}>
                                    <li>High School Diploma or GED</li>
                                    <li>On-the-Job Training (provided by employer)</li>
                                    <li>CPR Certification (may be required)</li>
                                    <li>Certification through DANB [OPTIONAL]</li>
                                </ul>
                            </div>
                        )}

                        {/* X-Ray Technician */}
                        <button
                            onClick={() => setOpenXray(o => !o)}
                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: "none", border: "none", borderBottom: "1px solid #a5d6a7", padding: "10px 0", cursor: "pointer", textAlign: "left", marginTop: "8px" }}
                        >
                            <h3 style={{ margin: 0, fontSize: "1.5rem", color: "#1b5e20" }}>X-Ray Technician (Dental Radiography)</h3>
                            <span style={{ fontSize: "1.2rem", color: "#2e7d32" }}>{openXray ? "▲" : "▼"}</span>
                        </button>
                        {openXray && (
                            <div style={{ paddingLeft: "10px", paddingTop: "8px", paddingBottom: "8px" }}>
                                <p style={{ ...styles.sectionText, marginBottom: "6px" }}><strong>Responsibilities:</strong> Taking dental radiographs (X-rays)</p>
                                <p style={{ ...styles.sectionText, marginBottom: "4px" }}><strong>Certification Sources:</strong></p>
                                <ul style={{ paddingLeft: "20px", color: "#2e7d32", fontSize: "1.1rem", lineHeight: "1.8", marginBottom: "10px" }}>
                                    <li><a href="https://www.yankeedental.com">Yankee Dental Radiology Certification Clinic</a></li>
                                    <li><a href="https://www.bu.edu/dental">Boston University Dental Continuing Education</a></li>
                                    <li><a href="https://mwcc.edu">Mount Wachusett Community College Radiology Certification</a></li>
                                    <li><a href="https://www.stcc.edu">Springfield Technical Community College Radiology Certificate</a></li>
                                    <li><a href="https://www.mass.gov/orgs/board-of-registration-in-dentistry">State Registration – Massachusetts Board of Registration in Dentistry</a></li>
                                </ul>
                                <p style={{ ...styles.sectionText, marginBottom: "4px" }}><strong>Requirements:</strong></p>
                                <ul style={{ paddingLeft: "20px", color: "#2e7d32", fontSize: "1.1rem", lineHeight: "1.8" }}>
                                    <li>High School Diploma or GED</li>
                                    <li>Pass the DANB Radiation Health &amp; Safety (RHS) Exam</li>
                                    <li>Register with the Massachusetts Board of Registration in Dentistry</li>
                                    <li>CPR Certification</li>
                                    <li>Continuing Education (12 hours annually)</li>
                                </ul>
                            </div>
                        )}

                        {/* Dental Assistant */}
                        <button
                            onClick={() => setOpenDentAssist(o => !o)}
                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: "none", border: "none", borderBottom: "1px solid #a5d6a7", padding: "10px 0", cursor: "pointer", textAlign: "left", marginTop: "8px" }}
                        >
                            <h3 style={{ margin: 0, fontSize: "1.5rem", color: "#1b5e20" }}>Dental Assistant</h3>
                            <span style={{ fontSize: "1.2rem", color: "#2e7d32" }}>{openDentAssist ? "▲" : "▼"}</span>
                        </button>
                        {openDentAssist && (
                            <div style={{ paddingLeft: "10px", paddingTop: "8px", paddingBottom: "8px" }}>
                                <p style={{ ...styles.sectionText, marginBottom: "4px" }}><strong>Requirements:</strong></p>
                                <ul style={{ paddingLeft: "20px", color: "#2e7d32", fontSize: "1.1rem", lineHeight: "1.8", marginBottom: "10px" }}>
                                    <li>High School Diploma or GED</li>
                                    <li>On-the-Job Training or completion of a Dental Assistant Program</li>
                                    <li>CPR Certification (courses available through the American Red Cross)</li>
                                    <li>Register with the Massachusetts Board of Registration in Dentistry</li>
                                    <li>Radiography Certification (DANB RHS exam required to take X-rays)</li>
                                    <li>Jurisprudence (Dental Ethics) Exam</li>
                                    <li>12 Continuing Education hours annually</li>
                                    <li>Expanded Functions Certification [Optional]</li>
                                </ul>
                                <p style={{ ...styles.sectionText, marginBottom: "4px" }}><strong>Certifications:</strong></p>
                                <ul style={{ paddingLeft: "20px", color: "#2e7d32", fontSize: "1.1rem", lineHeight: "1.8" }}>
                                    <li><a href="https://www.redcross.org/take-a-class/cpr">CPR Certification (American Red Cross)</a></li>
                                    <li><a href="https://www.mass.gov/orgs/board-of-registration-in-dentistry">Dental Assistant License Application</a></li>
                                    <li><a href="https://www.mass.gov/orgs/board-of-registration-in-dentistry">Dental Ethics / Jurisprudence Exam</a></li>
                                    <li>Radiography Certification Courses (RHS exam preparation):
                                        <ul style={{ paddingLeft: "20px", marginTop: "4px" }}>
                                            <li><a href="https://www.yankeedental.com">Radiography Yankee Dental Certification</a></li>
                                            <li><a href="https://www.bu.edu/dental">Radiography BU Certification</a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        )}

                        {/* Office Management Assistant */}
                        <button
                            onClick={() => setOpenOffice(o => !o)}
                            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", background: "none", border: "none", borderBottom: "1px solid #a5d6a7", padding: "10px 0", cursor: "pointer", textAlign: "left", marginTop: "8px" }}
                        >
                            <h3 style={{ margin: 0, fontSize: "1.5rem", color: "#1b5e20" }}>Office Management Assistant</h3>
                            <span style={{ fontSize: "1.2rem", color: "#2e7d32" }}>{openOffice ? "▲" : "▼"}</span>
                        </button>
                        {openOffice && (
                            <div style={{ paddingLeft: "10px", paddingTop: "8px", paddingBottom: "8px" }}>
                                <p style={{ ...styles.sectionText, marginBottom: "4px" }}><strong>Responsibilities:</strong></p>
                                <ul style={{ paddingLeft: "20px", color: "#2e7d32", fontSize: "1.1rem", lineHeight: "1.8" }}>
                                    <li>Scheduling, billing, and insurance processing</li>
                                    <li>Phone coordination and patient records</li>
                                    <li>Referral coordination and general office management</li>
                                </ul>
                            </div>
                        )}
                    </section>
                </div>
            </div>
        </ErrorBoundary>
    );
};
